import { LatestNewsResourcePackage } from "../../resources/LatestNewsResourcePackage";
import { NewsItem } from "./NewsItem";

export class NewsItemRankUp extends NewsItem {
    public constructor(id: string, newsResources: LatestNewsResourcePackage) {
        super(
            id,
            newsResources,
            newsResources.assets_views_latest_news_news_tooltip_green_png,
            newsResources.assets_views_latest_news_news_rank_up_png
        );
    }
}